import { Selector } from '@ngxs/store';
import { MatterClientIntakeFormState } from '../../../matter/client-intake/client-intake.state';
import { PortalInviteState } from '../../../portal-invite/portal-invite.state';
import { ClientIntakeForm } from '@models/client-intake';
import { PortalInvite } from '@models/portal-invites';
import { ClientIntakeFormTags } from '../models/clientIntake.model';

export class ClientIntakeSelector {
	@Selector([
		MatterClientIntakeFormState.getMostRecentActiveForm,
		PortalInviteState.getInviteByPortalServiceId,
	])
	static clientIntakeTags(
		clientIntakeForm: ClientIntakeForm | null,
		getInviteByPortalServiceId: (
			portalServiceId: string,
		) => PortalInvite | undefined,
	): ClientIntakeFormTags {
		if (!clientIntakeForm?.id)
			return {
				clientIntakes: {
					all: [],
				},
			};
		const invite = getInviteByPortalServiceId(clientIntakeForm.id);
		const tags: ClientIntakeFormTags = {
			clientIntakes: {
				all: [
					{
						portalInviteId: invite?.id,
					},
				],
				[clientIntakeForm.id]: {
					portalInviteId: invite?.id,
				},
			},
		};
		return tags;
	}
}
